import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';
import { designSystem } from '@/styles/styles';

function SvgComponent(props) {
    return (
        <Svg width={68} height={81} viewBox="0 0 68 81" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <Path
                d="M56.213.75v48.024h10.15l-.12.855-2.159 15.47-.09.647h-7.781V80.25H37.228V65.746H.75V53.158l.134-.192L36.822 1.073l.225-.323h19.166zM22.455 49.097H37.66V26.813L22.455 49.097z"
                fill={designSystem.colors.neutral900}
                stroke={ds.colorValue.icon.brand}
                strokeWidth={1.5}
            />
        </Svg>
    );
}

export default SvgComponent;
